import styled from 'styled-components';
import colors from 'utils/colors';

/* Commonly used styled components */

export const FormSectionContainer = styled.fieldset`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-evenly;
  width: 100%;
  padding-left: 1.5rem;
  border: none;
`;

export const Container = styled.div`
  width: ${props => props.width || '90%'};
  min-height: 16rem;
  margin: 0 auto 2rem;
  border-radius: 5px;
  background: ${props => props.background || '#fff'};
  padding-bottom: ${props => props.paddingBottom || '0'};
  -webkit-box-shadow: 0px 0px 20px 3px rgba(190, 190, 190, 1);
  -moz-box-shadow: 0px 0px 20px 3px rgba(190, 190, 190, 1);
  box-shadow: 0px 0px 20px 3px rgba(190, 190, 190, 1);

  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    width: 98%;
  }
`;

export const HeaderFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding: 1.5rem;
  border-left: 5px solid ${colors.primary};
  border-radius: 3px 3px 0px 0px;
`;

export const HeadingTitle = styled.p`
  width: fit-content;
  margin: 0;
  font-weight: 300;
  font-size: ${props => props.fontSize || '1.75rem'}
  line-height: 2.5rem;
  letter-spacing: 0.7px;
  color: ${colors.black};
`;

export const Title = styled.span`
  font-size: 1.25rem;
`;

export const Drawer = styled.div`
  height: 100vh;
  min-width: 50%;
  width: fit-content;
  top: 0;
  right: 0;
  background: #fff;
`;

export const DrawerHeader = styled.div`
  width: 100%;
  border-left: 5px solid ${colors.primary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  font-size: 1.75rem;
  font-weight: 300;
  background-color: ${colors.white};
`;

export const BlueTextPointer = styled.div`
  color: ${colors.primary};
  cursor: pointer;
  font-weight: 400;
  &:hover {
    color: ${colors.secondary};
  }
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: ${props => props.justify || 'space-between'};
  font-size: ${props => props.fontSize || 'inherit'};
  width: ${props => props.width || '100%'};
  align-content: ${props => props.align || 'center'};
  align-items: ${props => props.align || 'center'};
  margin: ${props => props.margin || '0.5rem 0'};
  padding: ${props => props.padding || '0'};
  flex-wrap: ${props => props.flexWrap || 'inherit'};
  background-color: ${props => props.background || 'inherit'};
`;

export const PaddingWrapper = styled.div`
  padding: ${props => props.padding || '1rem'};
  background: ${props => props.background || 'inherit'};
`;

export const PlainButton = styled.button`
  text-transform: uppercase;
  padding: 0.75rem 1rem;
  margin: ${props => props.margin || '0 0.5rem 0 1rem'};
  text-align: center;
  border: none;
  width: ${props => props.width || 'fit-content'};
  display: ${props => props.display || 'inline-block'};
  align-items: center;
  cursor: pointer;
  outline: none;
  letter-spacing: 1px;
  background: ${props => props.background || colors.primary};
  color: ${props => props.color || colors.white};
  font-size: 0.875rem;
  white-space: nowrap;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  border-radius: 5px;
  &:hover {
    background: ${colors.secondary};
  }
  &.warning {
    background: ${colors.red};
  }
  &.warning:hover {
    background: ${colors.darkRed};
  }
  &:disabled {
    background: ${colors.lightGray};
    cursor: not-allowed;
  }
`;

export const CategoryLabel = styled.div`
  color: ${colors.gray};
  margin-bottom: 0.5rem;
`;

export const BorderWrapper = styled.div`
  border-radius: ${props => props.radius || '5px'};
  border: 1px solid ${colors.lightestGray};
  margin: ${props => props.margin || 0};
  margin-bottom: 1rem;
  padding: ${props => props.padding || 0};
  background-color: #fff;
`;

export const ControlWrapper = styled.div`
  display: flex;
  justify-content: ${props => props.justify || 'flex-start'};
  align-items: center;
  min-width: 70%;
`;

export const SearchWrapper = styled.div`
  padding: ${props => props.padding || '1rem 2rem'};
  display: flex;
  justify-content: ${props => props.justify || 'space-between'};
  align-items: center;
`;

export const SectionHeader = styled.div`
  width: 100%;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  padding: ${props => props.padding || 0};
`;

export const RequiredLabel = styled.span`
  color: ${colors.muted};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.th`
  text-align: left;
  transition: all 0.3s ease;
  color: ${colors.lightGray};
  margin-bottom: 0.5rem;
  font-weight: 400;
  padding: 1rem;
`;

export const ResultsHeader = styled(TableHeader)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    display: none;
  }
`;

export const HeaderRow = styled.tr`
  background: ${colors.whiteGray};
  border-top: 1px solid ${colors.lightestGray};
  border-bottom: 1px solid ${colors.lightestGray};
  white-space: ${props => props.whiteSpace || 'unset'};
`;

export const ResultsHeaderRow = styled(HeaderRow)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    display: block;
    color: white;
    font-weight: bold;
  }
`;

export const TableRow = styled.tr`
  border-top: 1px solid ${colors.lightestGray};
  background: ${props => props.background || '#fff'};
  &:last-child {
    border-bottom: none;
  }
  width: 100%;
`;

export const ResultsRow = styled(TableRow)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    display: block;
    border-bottom: 3px solid ${colors.lightGray};
    &:nth-of-type(odd) {
      background: ${colors.whiteGray};
    }
  }
`;

export const HoverTableRow = styled(TableRow)`
  &:hover {
    cursor: pointer;
    background: ${colors.lightestGray};
  }
`;

export const ResultsHoverTableRow = styled(HoverTableRow)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    display: block;
    margin: 1rem auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 5px;
    width: 95%;
    -webkit-box-shadow: 0px 5px 5px 3px rgba(190, 190, 190, 1);
    -moz-box-shadow: 0px 5px 5px 3px rgba(190, 190, 190, 1);
    box-shadow: 0px 5px 5px 3px rgba(190, 190, 190, 1);

    &:last-child {
      border-bottom: 1px solid ${colors.lightGray};
    }
  }
`;

export const TableData = styled.td`
  font-weight: 400;
  padding: 1rem;
  color: ${props => props.color || colors.gray};
  &:last-child {
    word-break: ${props => props.wordBreak || 'normal'};
  }
`;

export const ResultsData = styled(TableData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    display: block;
    /* behave like a row*/
    border: none;
    border-bottom: 1px solid #c9c9c9;
    position: relative;
    padding-left: 50%;

    &::before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 1rem;
      left: 1rem;
      width: 45%;
      padding-right: 10px;
      white-space: nowrap;
    }
  }
`;

export const NoWrapTD = styled(TableData)`
  white-space: nowrap;
`;

export const TableDataIcons = styled(TableData)`
  text-align: right;
  width: 60px;
`;

export const NavigationControls = styled.div`
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NavigationLink = styled.span`
  color: ${colors.primary};
  cursor: pointer;
  &:hover {
    color: ${colors.secondary};
  }
`;

export const FilterWrapper = styled.span`
  .filter-selected {
    font-weight: bold;
  }
`;
